module.exports = __webpack_public_path__ + "static/media/sell_change_request_4.40db8e37.png";